import { CreateErrorUtil } from './createError.types';

export const createError: CreateErrorUtil = (name, message) => {
  const error = new Error(message);
  error.name = name;
  return error;
};
